/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import { FormFeedback } from 'reactstrap';
import FormatError from './format-error';

class BaseField extends Component {
  errorMessageCheck = () => {
    const {
      input,
      meta: { error },
    } = this.props;

    if (!error) {
      return null;
    }

    const name = this.props.hasOwnProperty('realName')
      ? this.props.realName
      : input.name;

    return (
      <FormFeedback>
        <FormatError name={name} error={error} />
      </FormFeedback>
    );
  };

  errorMessage = () => {
    const {
      input,
      meta: { touched, error },
    } = this.props;

    if (!touched || !error) {
      return null;
    }

    const name = this.props.hasOwnProperty('realName')
      ? this.props.realName
      : input.name;

    return (
      <FormFeedback>
        <FormatError name={name} error={error} />
      </FormFeedback>
    );
  };

  warningMessage = () => {
    const {
      input,
      meta: { touched, error, warning },
    } = this.props;

    if (!touched || error || !warning) {
      return null;
    }

    const name = this.props.hasOwnProperty('realName')
      ? this.props.realName
      : input.name;

    return (
      <span className="form-text text-warning">
        <FormatError name={name} error={error} />
      </span>
    );
  };
}

export default BaseField;
